var mobileDeviceUserAgentRegularExpression = /iPhone|iPad|iPod|Android/i;
export var isMobileDevice = () => typeof global !== 'undefined' && global.navigator && mobileDeviceUserAgentRegularExpression.test(global.navigator.userAgent);
//# sourceMappingURL=isMobileDevice.js.map